import { render, staticRenderFns } from "./CommentDialog.vue?vue&type=template&id=a14ad994&scoped=true"
import script from "./CommentDialog.vue?vue&type=script&lang=js"
export * from "./CommentDialog.vue?vue&type=script&lang=js"
import style0 from "./CommentDialog.vue?vue&type=style&index=0&id=a14ad994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14ad994",
  null
  
)

export default component.exports